import React, { createContext, useContext, useEffect, useState } from 'react'

const AppFetchContext = createContext()

export const STATUS = {
  initial: 0,
  loading: 1,
  success: 2,
  error: 3,
}

const getQueryParams = productSlugs => {
  return productSlugs.join(',')
}

const getListingObject = response => {
  const resultsObject = {}
  response.listings.forEach(item => {
    resultsObject[item.slug] = item
  })
  return resultsObject
}

export const AppFetchContextProvider = ({ children, productSlugs }) => {
  const [status, setStatus] = useState(STATUS.initial)
  const [products, setProducts] = useState({})

  useEffect(() => {
    setStatus(STATUS.loading)
    const queryParams = getQueryParams(productSlugs)

    // Prevent unneccessary fetches when the queryParams are empty
    if (!queryParams) return

    fetch(`/api/listings?listing_slugs=${queryParams}`)
      .then(result => result.json())
      .then(listingsResponse => {
        if (listingsResponse.listings.length > 0) {
          setProducts(getListingObject(listingsResponse))
          setStatus(STATUS.success)
        } else {
          setStatus(STATUS.error)
        }
      })
      .catch(() => {
        setStatus(STATUS.error)
      })
  }, [setStatus, setProducts, productSlugs])

  return <AppFetchContext.Provider value={{ status, products }}>{children}</AppFetchContext.Provider>
}

const useAppFetchContext = () => {
  return useContext(AppFetchContext)
}

export default useAppFetchContext
